import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M6.055 4.069v-.006m7.473 5.494v-.314a5.49 5.49 0 0 0-3.589-5.174v2.049a.47.47 0 0 1-.94 0V2.935a5.387 5.387 0 0 0-2 0v3.183a.47.47 0 0 1-.94 0V4.069a5.491 5.491 0 0 0-3.587 5.174v.314a1.309 1.309 0 0 0-1.222 1.259c0 1.729 3.483 2.343 6.747 2.343s6.753-.614 6.753-2.343a1.309 1.309 0 0 0-1.222-1.259ZM11.179 10.7A12.424 12.424 0 0 1 8 11.073a12.47 12.47 0 0 1-3.182-.37.47.47 0 0 1-.339-.57.464.464 0 0 1 .57-.338A11.96 11.96 0 0 0 8 10.133a11.979 11.979 0 0 0 2.954-.333.468.468 0 1 1 .225.908Zm-1.24-6.631v-.006';
const draw24px = 'M8.9,5.74h0M20.83,14.5V14A8.76,8.76,0,0,0,15.1,5.74V9a.75.75,0,0,1-1.5,0V3.93a8.61,8.61,0,0,0-3.2,0V9A.75.75,0,0,1,8.9,9V5.74A8.77,8.77,0,0,0,3.18,14v.5a2.09,2.09,0,0,0-1.95,2c0,2.76,5.56,3.74,10.77,3.74s10.78-1,10.78-3.74A2.09,2.09,0,0,0,20.83,14.5Zm-3.75,1.83a19.85,19.85,0,0,1-5.08.59,19.93,19.93,0,0,1-5.08-.59.75.75,0,0,1-.54-.91.74.74,0,0,1,.91-.54,19,19,0,0,0,4.71.54,19.06,19.06,0,0,0,4.72-.54.75.75,0,1,1,.36,1.45Zm-2-10.59h0';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const HardhatFilledIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'hardhatFilled'));
HardhatFilledIcon.displayName = 'HardhatFilledIcon';
HardhatFilledIcon.propTypes = Icon.propTypes;
HardhatFilledIcon.renderIcon = props => /*#__PURE__*/React.createElement(HardhatFilledIcon, props);
export default HardhatFilledIcon;
//# sourceMappingURL=HardhatFilledIcon.js.map